<!--
 * @Description  : 关闭包年服务
 * @Author       : wuxuebing
 * @Date         : 2025-03-27 16:17:42
 * @LastEditors  : wuxuebing
 * @LastEditTime : 2025-03-28 11:12:16
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\platform-services\components\close-dialog.vue
-->
<template>
    <el-dialog :visible.sync="visible" class="" width="1000px" :title="title" :close-on-click-modal="false"
        @closed="handleClosed" center>
        <Panel title="#1 服务信息">
            <el-form ref="serviceInfo" :model="serviceInfo" label-width="110px" class="tableForm">
                <el-form-item label="状态">
                    <div class="pdl20"> {{ serviceInfo.effectiveStatus }}</div>
                </el-form-item>
                <el-form-item label="服务类型">
                    <div class="pdl20" v-if="serviceInfo.payType == 0">平台技术服务费（包年）</div>
                </el-form-item>
                <el-form-item label="服务有效期">
                    <div class="pdl20">{{ serviceInfo.expirationDate }}

                    </div>
                </el-form-item>
            </el-form>
        </Panel>
        <Panel title="#2 享受权益">
            <el-table ref="xTable" highlight-current-row :data="tableData" min-height="230px" class="mt10" border>
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="rightsType" label="权益类型" header-align="center" width="160"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="rightsContent" label="权益内容" header-align="center" min-width="200"
                    show-overflow-tooltip></el-table-column>
            </el-table>
        </Panel>
        <Panel title="#3 关闭服务">
            <el-form ref="closeForm" :model="closeForm" :rules="closeRules" label-width="160px" class="tableForm"
                v-if="visible">
                <el-form-item label="关闭包年服务时间" prop="closeTime">
                    <el-date-picker v-model="closeForm.closeTime" value-format="yyyy-MM-dd" type="date"
                        placeholder="选择日期" :picker-options="closeDatePicker">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="关闭原因" prop="remark">
                    <el-input v-model="closeForm.remark" placeholder="请输入" maxlength="50"></el-input>

                </el-form-item>
                <el-form-item label="操作人">
                    <el-input v-model="closeForm.createUser" disabled></el-input>

                </el-form-item>

            </el-form>
        </Panel>

        <div slot="footer" class="dialog-footer text-center">
            <el-button class="btn" size="small" @click="handleClosed">取 消</el-button>
            <el-button type="primary" size="small" class="btn btn-blue" :loading="btnLoading" @click="doSave">确
                定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import { closeService, getServiceFeeDetail } from "api/modules/templateConfiguration";
import Panel from "@/components/panel/Panel";
export default {
    components: { Panel },
    filters: {
        timeFilter(val) {
            if (val) {
                return val.split(" ")[0];
            }
        },
    },
    data() {
        return {
            visible: false,
            btnLoading: false,
            title: "关闭包年服务",
            closeForm: {
                id: '', // 服务id
                closeTime: '', // 关闭时间
                remark: "", // 关闭原因
                createUser: "", // 开通人
            },
            closeRules: {
                closeTime: [{ required: true, message: "请选择关闭包年服务时间", trigger: "change" }],
                remark: [{ required: true, message: "请输入关闭原因", trigger: "blur" }],
            },
            serviceInfo: {}, //
            tableData: [],
            closeDatePicker: this.closeDate()
        };
    },
    methods: {

        // 初始化弹窗
        initDialog(id) {

            // id赋值
            this.closeForm.id = id;
            // 操作人赋值
            this.closeForm.createUser = this.userInfo.sname;
            // 清空关闭日期
            this.closeForm.closeTime = "";
            // 清空关闭原因
            this.closeForm.remark = "";
            this.getDetail(id);
            // 打开弹框
            this.visible = true;
        },


        // 关闭日期
        closeDate() {
            let that = this;
            return {
                disabledDate(time) {

                    const today = new Date();

                    // 设置最大日期
                    let endDate = that.serviceInfo.expirationDate ? that.serviceInfo.expirationDate.slice(13, 24) : "2099-12-31";

                    const maxDate = new Date(endDate);

                    // 设置不可选日期 当天-服务器最后一天
                    return time.getTime() < (today.getTime() - 86400000) || time.getTime() > maxDate.getTime();

                },
            };
        },
        //详情接口
        getDetail(id) {
            getServiceFeeDetail({ id: id })
                .then((res) => {

                    this.tableData = res.data.serviceRights;
                    // 服务信息
                    this.serviceInfo = res.data.serviceInfo;

                })
                .catch((err) => { });
        },

        // 保存操作
        doSave() {
            this.btnLoading = true;
            this.$refs.closeForm.validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.closeForm,
                    };
                    closeService(params)
                        .then((res) => {
                            this.btnLoading = false;
                            this.$message.success("操作成功");
                            this.handleClosed()
                            this.$emit("update");
                        })
                        .catch((err) => {
                            this.btnLoading = false;
                        });
                } else {
                    this.$message.warning('有必填项未填，请填写！')
                    this.btnLoading = false
                    return false

                }
            });
        },

        // 关闭弹窗
        handleClosed() {
            this.visible = false;
        },
    },
    computed: {
        ...mapState("user", {
            userInfo: (state) => state.userInfo,
        }),

    }
};
</script>

<style scoped lang="less">
/deep/.el-form {
    &.tableForm {
        .el-form-item {
            margin-bottom: 0;
            margin-right: 0;
            display: flex;
        }

        .el-form-item__label {
            width: 200px;
            // border: 0;
            border: 1px solid #dcdcdc;
            border-right: 0;
            border-bottom: 0;
            line-height: 46px;
            // margin: 0 1px;
            background: #fafafa;
            padding-right: 20px;
        }

        .el-form-item__content {
            border: 1px solid #dcdcdc;
            border-bottom: 0;
            width: calc(100% - 110px);
            background-color: #fff;
            line-height: 46px;
            text-align: left;
            margin-left: 0 !important;
            // padding-left: 20px;
        }

        .el-form-item:last-child {

            .el-form-item__content,
            .el-form-item__label {
                border-bottom: 1px solid #dcdcdc;
            }
        }

        .el-input {
            width: 100%;

        }

        .el-input__inner {
            min-height: 46px !important;
            line-height: 46px !important;
            padding-left: 20px;
            border: 0;
            border-radius: 0;
        }

        .vxe-switch {
            padding-left: 20px;
        }

        .el-input.is-active .el-input__inner,
        .el-input__inner:focus {
            border: 1px solid #ccc;
        }

        .el-date-editor .el-input__inner {
            padding-left: 30px;
        }

        .el-form-item.is-error .el-input__inner,
        .el-form-item.is-error .el-input__inner:focus,
        .el-form-item.is-error .el-textarea__inner,
        .el-form-item.is-error .el-textarea__inner:focus {
            border: 1px solid #f56c6c;
        }

        .el-select {
            width: 100%;
        }

        .el-switch,
        .el-checkbox-group,
        .el-radio-group {
            margin-left: 20px;
        }

        .el-textarea__inner {
            border: none;
            border-radius: 0;
            padding-left: 20px;
        }

        .el-textarea .el-input__count {
            background-color: rgba(255, 255, 255, 0);
            bottom: -10px;
        }

        .el-textarea__inner:focus {
            border: 1px solid #dcdcdc;
            outline: none;
            border-color: #409eff;
        }

        .el-cascader {
            width: 100%;
        }

        .el-input-group__append,
        .el-input-group__prepend {
            background-color: #f4f7fa;
            color: #666;
            border-color: transparent;
        }
    }

    .el-input.is-disabled .el-input__inner {
        // background-color: #fff;
    }
}

.pdl20 {
    padding-left: 20px;
}
</style>